import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { Grid, Card, CardContent } from '@material-ui/core';
import StandardDialog from './StandardDialog';
import RenderSelectFieldRedux from './RenderSelectFieldRedux';

const validate = values => {
    const error  = {}
    if (!values.number) {
        error.number = "El campo Número de cuenta es requerido"
    }
    return error
}

const InternalForm = props => {
    const { handleSubmit, onCancelAction, submitting, pristine } = props
    return  <Card  variant="outlined"> 
                <CardContent>
                    <form onSubmit = {handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <Field
                                    name="number"
                                    id= "number"
                                    component={ RenderTextFieldRedux }
                                    label="Número de Cuenta"
                                    type="number"
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Field
                                    data = {
                                        [
                                            { id: 1, value: 'AHORRO VISTA', text: 'AHORRO VISTA'},
                                            { id: 2, value: 'CUENTA SUEÑITOS', text: 'CUENTA SUEÑITOS' },
                                            { id: 3, value: 'MULTIAHORROS', text: 'MULTIAHORROS' },
                                            { id: 4, value: 'MULTIAHORROS PRODUCTOR', text: 'MULTIAHORROS PRODUCTOR' },
                                            { id: 5, value: 'MULTIAHORROS JUBILACION', text: 'MULTIAHORROS JUBILACION' },
                                            { id: 6, value: 'MULTIAHORROS MIS DECIMOS', text: 'MULTIAHORROS MIS DECIMOS' },
                                            { id: 7, value: 'AHORRO FAMILIA', text: 'AHORRO FAMILIA' },
                                            { id: 8, value: 'CERTIFICADOS DE APORTACIÓN', text: 'CERTIFICADOS DE APORTACIÓN' },
                                            { id: 9, value: 'INTEGRACIÓN DE CAPITAL', text: 'INTEGRACIÓN DE CAPITAL' },
                                            { id: 10, value: 'CORRESPONSALÍA', text: 'CORRESPONSALÍA' },
                                            { id: 11, value: 'CUENTA BÁSICA', text: 'CUENTA BÁSICA'},
                                        ]
                                    }
                                    labelId="demo-simple-select-filled-label"
                                    id="type_name"
                                    name="type_name"
                                    valueData="AHORRO VISTA"
                                    label= { "Tipo de cuenta" }
                                    component={ RenderSelectFieldRedux } >
                                </Field>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    name="name"
                                    id= "name"
                                    required
                                    // value= {data.number}
                                    // onChange={handleChangeCedule}
                                    component={ RenderTextFieldRedux }
                                    label="Nombre del beneficiario"
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    name="email"
                                    id= "email"
                                    required
                                    // value= {data.number}
                                    // onChange={handleChangeCedule}
                                    component={ RenderTextFieldRedux }
                                    label="Correo electrónico"
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            
                            <br></br>
                            <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                                <Button 
                                    style = {{ width : "140px"}}
                                    variant="contained"
                                    color="primary"
                                    type="submit" 
                                    disabled={pristine || submitting}
                                >
                                    Guardar
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                                <Button style = {{ width : "140px"}} variant="contained" color="primary" onClick = { () => onCancelAction() }>Cancelar</Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
}

const InternalReduxForm = reduxForm(
    {
        form: 'InternalForm',
        validate,
    }
)(InternalForm)


const BeneficiaryInternalForm = props => {
    const {  onCloseBeneficiaryForm, internalBeneficiary, onAcceptClick } = props
    const {open, data } = internalBeneficiary

    const handleSubmit = (values) => {
        onAcceptClick(values)
    }
    
    return (
            <StandardDialog
                title = { 'Editar beneficiario'}
                open = {open}
                handleClose = {onCloseBeneficiaryForm}
            >
                <InternalReduxForm
                    onSubmit = { handleSubmit }
                    onCancelAction = {onCloseBeneficiaryForm}
                    // data = {data}
                    initialValues = {data} />
            </StandardDialog>
    );
};

BeneficiaryInternalForm.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryInternalForm;